import { useMemo } from "react";
import { COLORS } from "utils/colors";
import Spectrogram from "./Spectrogram";

export * from "./Spectrogram.types";
export { Spectrogram };

export const SpectrogramComponent = ({
  lowerFrequency,
  upperFrequency,
  band,
  data,
  initialData,
  onTakeSnapshot,
}) => {
  const xValues = useMemo(() => {
    const values = [];
    const freqBand = upperFrequency - lowerFrequency;

    for (let i = 0; i <= 8; i++) {
      if (i % 2 === 1) {
        values.push("");
      } else {
        values.push(
          `${(lowerFrequency + (i * freqBand) / 8).toFixed(0)}MHz`
        );
      }
    }

    return freqBand > 1 ? values : [];
  }, [lowerFrequency, upperFrequency]);

  const initialSpectrogramData = useMemo(() => {
    if (!initialData?.data?.spectrograms) return null;

    const spec = initialData.data.spectrograms.find(
      (el) => el.localOscillatorFrequency === band
    );

    return spec
      ? {
          imageData: spec.powerSpectralDensity,
          rows: spec.sampleCount,
        }
      : null;
  }, [band, initialData]);

  return (
    <Spectrogram
      data={{
        lowerFrequency,
        upperFrequency,
        x: xValues,
        y: data?.powerSpectralDensity || [],
        z: 0,
      }}
      initialData={initialSpectrogramData}
      layout={{
        width: 452,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        line: {
          isHidden: false,
          height: 100,
        },
        heatmap: {
          height: 300,
          marginTop: 25,
        },
        scale: {
          isHidden: false,
          color: COLORS.greyFontColor,
          height: 24,
          marginTop: 25,
        },
      }}
      triggers={onTakeSnapshot}
      options={{
        xAxis: {
          displayAxis: true,
          displayGrid: true,
          values: xValues,
          color: COLORS.greyFontColor,
        },
        yAxis: {
          displayAxis: true,
          displayGrid: true,
          values: [0, 60],
          offset: 20,
          color: COLORS.greyFontColor,
          units: "dB",
        },
        zAxis: {
          displayAxis: false,
          displayBins: 100,
          color: "white",
        },
        theme: "blue-green-red",
      }}
    />
  );
};